import { Card } from '@aws-amplify/ui-react';
import React from 'react';
import GaugeChart from 'react-gauge-chart'

const GaugeMeter: React.FC<{}> = () => {
    return (
        <Card height="100%" borderRadius="15px" style={{background:'transparent'}}>
            <div className="card-content">
                <GaugeChart
                    id="gauge-chart1"
                    nrOfLevels={3}
                    colors={['#e10019', '#fab40f', '#3ca528']}
                    arcWidth={0.35}
                    percent={0.50}
                    arcPadding={0.02}
                    cornerRadius={0}
                    needleScale={0.85}
                    needleColor="#2d3c55"
                    needleBaseColor="#2d3c55"
                    hideText={true}
                    style={{ width: 270, margin: 'auto' }}
                />
            </div>
        </Card>
    )
}

export default GaugeMeter;